module.exports = __webpack_public_path__ + "img/logoLorfolio.52a01dbd.svg";